const getDateRange = urlString => {
  const regexpDateRange = /custom_(\d+)_?(\d+)/

  const isRegexpValid = regexpDateRange.test(urlString)

  if (isRegexpValid) {
    const paramsRegexpDateRange = regexpDateRange.exec(urlString)

    return {
      value: `${paramsRegexpDateRange[0]}`,
      gte: paramsRegexpDateRange[1],
      lte: paramsRegexpDateRange[2],
    }
  }
  return null
}

export default getDateRange
